export default __webpack_public_path__ + "static/media/potassium.a95c7262.jpg";